import { Globe } from "lucide-react";

const LINK_CONFIG: Record<string, { label: string; icon: React.ReactNode }> = {
  homepage: {
    label: "Website",
    icon: <Globe className="h-3.5 w-3.5" />,
  },
  instagram: {
    label: "Instagram",
    icon: (
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  twitter: {
    label: "X / Twitter",
    icon: (
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  facebook: {
    label: "Facebook",
    icon: (
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  youtube: {
    label: "YouTube",
    icon: (
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z" />
        <path d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="black" />
      </svg>
    ),
  },
  bandcamp: {
    label: "Bandcamp",
    icon: (
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="currentColor">
        <path d="M0 18.75l7.437-13.5H24l-7.438 13.5z" />
      </svg>
    ),
  },
  soundcloud: {
    label: "SoundCloud",
    icon: (
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="currentColor">
        <path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c-.009-.06-.049-.1-.1-.1m-.899.828c-.06 0-.091.037-.104.094L0 14.479l.172 1.282c.013.06.045.094.104.094.057 0 .09-.037.104-.094l.194-1.282-.194-1.332c-.014-.057-.047-.094-.104-.094m1.806-.654c-.066 0-.109.053-.116.109l-.222 2.174.222 2.104c.007.057.05.104.116.104s.109-.047.116-.104l.253-2.104-.253-2.174c-.007-.056-.05-.109-.116-.109m.882-.624c-.074 0-.12.058-.127.116l-.214 2.233.214 2.096c.007.064.053.12.127.12s.12-.056.127-.12l.243-2.096-.243-2.233c-.007-.058-.053-.116-.127-.116m.874-.468c-.083 0-.127.06-.134.12l-.192 2.324.192 2.104c.007.064.051.12.134.12.082 0 .127-.056.134-.12l.217-2.104-.217-2.324c-.007-.06-.052-.12-.134-.12m.903-.39c-.09 0-.143.067-.15.135l-.17 2.38.17 2.07c.007.067.06.127.15.127.09 0 .142-.06.15-.127l.193-2.07-.193-2.38c-.008-.068-.06-.135-.15-.135m.94-.22c-.098 0-.155.074-.161.142l-.155 2.444.155 2.08c.006.074.063.135.161.135s.155-.061.161-.135l.175-2.08-.175-2.444c-.006-.068-.063-.142-.161-.142m.958-.143c-.107 0-.163.082-.17.157l-.141 2.427.141 2.065c.007.075.063.15.17.15.105 0 .162-.075.17-.15l.158-2.065-.158-2.427c-.008-.075-.065-.157-.17-.157m.986-.023c-.116 0-.173.09-.18.165l-.12 2.382.12 2.05c.007.082.064.157.18.157.114 0 .172-.075.18-.157l.135-2.05-.135-2.382c-.008-.075-.066-.165-.18-.165m1.032.186c-.124 0-.187.09-.194.172l-.1 2.14.1 2.028c.007.09.07.165.194.165.123 0 .186-.075.194-.165l.115-2.028-.115-2.14c-.008-.082-.071-.172-.194-.172m1.043-.17c-.135 0-.195.097-.203.18l-.087 2.185.087 2.02c.008.09.068.165.203.165.134 0 .195-.075.203-.165l.098-2.02-.098-2.185c-.008-.083-.069-.18-.203-.18m1.08.08c-.143 0-.21.105-.218.188l-.073 2.034.073 2.02c.008.09.075.172.218.172.142 0 .209-.082.218-.172l.082-2.02-.082-2.034c-.009-.083-.076-.188-.218-.188m1.074.303c-.15 0-.218.105-.226.195l-.058 1.73.058 1.983c.008.09.076.172.226.172.15 0 .217-.082.226-.172l.066-1.983-.066-1.73c-.009-.09-.076-.195-.226-.195m1.106-.56c-.008-.09-.083-.195-.233-.195s-.225.105-.233.195l-.054 2.058.054 1.963c.008.097.083.18.233.18s.225-.083.233-.18l.062-1.963-.062-2.058m.96-.192c-.24 0-.27.12-.27.18l-.038 2.28.038 1.94c0 .06.03.18.27.18.225 0 .27-.12.27-.18l.044-1.94-.044-2.28c0-.06-.045-.18-.27-.18m13.24 1.302c-.5 0-.974.1-1.405.282-.29-3.263-3.065-5.82-6.44-5.82-1.675 0-3.2.672-4.318 1.77-.354.344-.42.668-.42 1.002v10.1c0 .348.265.645.606.676l11.977.004c2.202 0 3.985-1.792 3.985-4.003 0-2.21-1.783-4.01-3.985-4.01" />
      </svg>
    ),
  },
  itunes: {
    label: "Apple Music",
    icon: (
      <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="currentColor">
        <path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043A5.022 5.022 0 0019.7.28a10.49 10.49 0 00-1.564-.15C17.51.058 16.96.032 14.545.02H9.448C7.03.032 6.48.058 5.855.13a10.49 10.49 0 00-1.564.15A5.072 5.072 0 002.42.89C1.3 1.625.556 2.625.24 3.935a9.23 9.23 0 00-.24 2.19c-.1.625-.126 1.175-.138 3.59v4.57c.012 2.415.038 2.965.138 3.59a9.23 9.23 0 00.24 2.19c.317 1.31 1.062 2.31 2.18 3.043a5.1 5.1 0 001.872.61 10.49 10.49 0 001.564.15c.625.072 1.175.098 3.59.11h5.1c2.415-.012 2.965-.038 3.59-.11a10.49 10.49 0 001.564-.15 5.1 5.1 0 001.872-.61c1.118-.733 1.863-1.733 2.18-3.043a9.23 9.23 0 00.24-2.19c.1-.625.126-1.175.138-3.59v-4.57c-.012-2.415-.038-2.965-.138-3.59zM12 18.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13zm0-10.4a3.9 3.9 0 100 7.8 3.9 3.9 0 000-7.8z" />
      </svg>
    ),
  },
};

const LINK_ORDER = ["homepage", "instagram", "twitter", "youtube", "facebook", "bandcamp", "soundcloud", "itunes"];

export function ArtistExternalLinks({
  links,
  size = "md",
}: {
  links?: Record<string, { url: string }[]> | null;
  size?: "sm" | "md";
}) {
  if (!links) return null;

  const displayLinks = LINK_ORDER
    .filter((key) => links[key]?.[0]?.url)
    .map((key) => ({
      key,
      url: links[key][0].url,
      ...LINK_CONFIG[key],
    }));

  if (displayLinks.length === 0) return null;

  const sizeClasses = size === "sm" ? "h-6 w-6" : "h-8 w-8";

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {displayLinks.map(({ key, url, label, icon }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={`flex ${sizeClasses} items-center justify-center rounded-full border border-neutral-700 text-neutral-400 transition-colors hover:border-neutral-500 hover:text-white`}
          title={label}
        >
          {icon}
        </a>
      ))}
    </div>
  );
}
